'use strict';

import Price from './price';

function Deal (object) {
  const price = object.get('price');

  this.price = new Price(price.get('total'));
  this.pricePerAre = price.getIn('perAre') ? new Price(price.get('perAre')) : null;
  this.pricePerSquareMeter = price.get('perSquareMeter') ? new Price(price.get('perSquareMeter')) : null;
}

const proto = Deal.prototype;

proto.getPrice = function () {
  return this.price;
};

proto.getPricePerAre = function () {
  return this.pricePerAre;
};

proto.getPricePerSquareMeter = function () {
  return this.pricePerSquareMeter;
};

export default Deal;



// WEBPACK FOOTER //
// ./src/classes/finance/deal.js